export { default } from './chat-avatar';
